var map = {
	"./Aviatrix.svg": 94457,
	"./Baccarat New.svg": 21770,
	"./Baccarat.svg": 77584,
	"./Bingo and Keno.svg": 14708,
	"./Bingo.svg": 98592,
	"./Blackjack.svg": 9161,
	"./Cards.svg": 75112,
	"./Cashout.svg": 14582,
	"./Classic Slots.svg": 6354,
	"./Crash Games.svg": 14429,
	"./Crash.svg": 74788,
	"./Dice Games.svg": 19983,
	"./Dice.svg": 71254,
	"./Drops and Wins.svg": 58889,
	"./Games.svg": 74544,
	"./GamesLobby.svg": 4808,
	"./Holdem.svg": 73046,
	"./Infinity Play.svg": 86207,
	"./Instant Win.svg": 47148,
	"./Instant.svg": 11754,
	"./JetX.svg": 29256,
	"./Keno.svg": 97354,
	"./Live games.svg": 38248,
	"./Lucky tapper.svg": 5307,
	"./Mine.svg": 30606,
	"./New.svg": 47119,
	"./Others.svg": 73690,
	"./Plinko.svg": 41744,
	"./Poker.svg": 68290,
	"./RGS - VSB.svg": 93077,
	"./Roulette.svg": 17055,
	"./Scratch card.svg": 75591,
	"./Scratchcard.svg": 70681,
	"./SetDefault.svg": 69608,
	"./Slot copy 2.svg": 35616,
	"./Slot.svg": 50119,
	"./Slots.svg": 92662,
	"./Table and Cards.svg": 41535,
	"./Tower.svg": 15242,
	"./Video Slots.svg": 29087,
	"./Virtuals.svg": 14507,
	"./Wheel of Fortune.svg": 87768,
	"./XGames.svg": 17698,
	"./amarix.svg": 71915,
	"./aviatorhome.avif": 50984,
	"./aviatrix3.svg": 71768,
	"./aviatrixhome.avif": 51162,
	"./booming games.svg": 10559,
	"./booming.svg": 39494,
	"./casinohome.avif": 3955,
	"./daemon/peakunifyprinter.xml": 44249,
	"./default.svg": 55926,
	"./eurovirtuals - Copy.svg": 18504,
	"./eurovirtuals.svg": 9852,
	"./fazi.png": 37987,
	"./fazi.svg": 27827,
	"./fazi3.svg": 94010,
	"./hacksaw gaming.svg": 53078,
	"./home.svg": 53174,
	"./iconic21.svg": 18267,
	"./ligi-sure.svg": 6616,
	"./onlyplay.svg": 16595,
	"./platipus.svg": 42207,
	"./popular.svg": 6030,
	"./pragmatic.svg": 25593,
	"./pragmatic3.svg": 99416,
	"./smartsoft.svg": 42150,
	"./smartsoft3.svg": 23961,
	"./spinhome.avif": 63348,
	"./split the pot.png": 64323,
	"./split the pot.svg": 63965,
	"./split the pot3.svg": 4436,
	"./stp.svg": 62294,
	"./surecoin.svg": 30395,
	"./turbo games.svg": 86052,
	"./windows-service.exe": 88322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63011;